// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/finalize_project_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProjectImage } from "./vision_asset_pb";
import { file_vision_assets_v1_vision_asset } from "./vision_asset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/finalize_project_image.proto.
 */
export const file_vision_assets_v1_finalize_project_image: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYXNzZXRzL3YxL2ZpbmFsaXplX3Byb2plY3RfaW1hZ2UucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIskBChtGaW5hbGl6ZVByb2plY3RJbWFnZVJlcXVlc3QSSwoGcGFyYW1zGAEgASgLMjsucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRmluYWxpemVQcm9qZWN0SW1hZ2VSZXF1ZXN0LlBhcmFtcxIYChBjbGllbnRfdXBsb2FkX2lkGAIgASgJGkMKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEhAKCGFzc2V0X2lkGAIgASgJEhMKC2xvY2F0aW9uX2lkGAMgASgJIqwBChxGaW5hbGl6ZVByb2plY3RJbWFnZVJlc3BvbnNlEkwKBnJlc3VsdBgBIAEoCzI8LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkZpbmFsaXplUHJvamVjdEltYWdlUmVzcG9uc2UuUmVzdWx0Gj4KBlJlc3VsdBI0CgVpbWFnZRgBIAEoCzIlLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlByb2plY3RJbWFnZWIGcHJvdG8z", [file_vision_assets_v1_vision_asset]);

/**
 * @generated from message protos.vision.assets.v1.FinalizeProjectImageRequest
 */
export type FinalizeProjectImageRequest = Message<"protos.vision.assets.v1.FinalizeProjectImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeProjectImageRequest.Params params = 1;
   */
  params?: FinalizeProjectImageRequest_Params | undefined;

  /**
   * @generated from field: string client_upload_id = 2;
   */
  clientUploadId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeProjectImageRequest.
 * Use `create(FinalizeProjectImageRequestSchema)` to create a new message.
 */
export const FinalizeProjectImageRequestSchema: GenMessage<FinalizeProjectImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_project_image, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeProjectImageRequest.Params
 */
export type FinalizeProjectImageRequest_Params = Message<"protos.vision.assets.v1.FinalizeProjectImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;

  /**
   * @generated from field: string location_id = 3;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeProjectImageRequest.Params.
 * Use `create(FinalizeProjectImageRequest_ParamsSchema)` to create a new message.
 */
export const FinalizeProjectImageRequest_ParamsSchema: GenMessage<FinalizeProjectImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_project_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeProjectImageResponse
 */
export type FinalizeProjectImageResponse = Message<"protos.vision.assets.v1.FinalizeProjectImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeProjectImageResponse.Result result = 1;
   */
  result?: FinalizeProjectImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeProjectImageResponse.
 * Use `create(FinalizeProjectImageResponseSchema)` to create a new message.
 */
export const FinalizeProjectImageResponseSchema: GenMessage<FinalizeProjectImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_project_image, 1);

/**
 * @generated from message protos.vision.assets.v1.FinalizeProjectImageResponse.Result
 */
export type FinalizeProjectImageResponse_Result = Message<"protos.vision.assets.v1.FinalizeProjectImageResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ProjectImage image = 1;
   */
  image?: ProjectImage | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeProjectImageResponse.Result.
 * Use `create(FinalizeProjectImageResponse_ResultSchema)` to create a new message.
 */
export const FinalizeProjectImageResponse_ResultSchema: GenMessage<FinalizeProjectImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_project_image, 1, 0);

